import ModalComponent from './modalComponent';
import 'base_global_css/components/variationGroupModal.scss';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');

// TODO: force scrolltop on open

/**
 * VariationGroupModal component
 */
export default class VariationGroupModal extends ModalComponent {
    constructor(...args) {
        super(...args);
        return this;
    }

    enable() {
        if (!this.state.data) return;

        this.createModal({
            body: this.state.data
        });
        this.bindEvents();
    }

    onOpen() {
        if (this.modalId === 'view-all-colors-modal') {
            tealiumEnable.getAnalyticsData('showViewAllColorsTracking');
        }
        setTimeout(() => {
            const tilesElement = document.querySelector('.variation-group');
            tilesElement.classList.add('modal-loaded');
        }, 400);
    }

    bindEvents() {
        $('.variation-group__link', this.$el).on('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const { url, displayId, attrValue } = event.currentTarget.dataset;
            $('body').trigger('variationgroup:selected', [url, displayId, attrValue]);
            this.close();
        });
    }

}
